export default __webpack_public_path__ + "static/Entenda0137-08958adccf2b4ff2ddce95201ae00c10.jpg";